import { readonly, ref } from 'vue'

import { DEFAULT_THEME, resolveTheme, type ThemeKey } from '@/core/theme/index'

const current = ref<ThemeKey>(DEFAULT_THEME)

/**
 * 테마 전환. <html data-theme="..."> 속성으로 적용되며
 * 모든 색상은 tokens.css의 CSS 변수를 통해 반응한다.
 */
export function useTheme() {
  function applyTheme(theme: ThemeKey) {
    current.value = theme
    document.documentElement.dataset.theme = theme
  }

  /** shopData.theme 원본 값을 그대로 넘기면 매핑 + 폴백까지 처리 */
  function applyShopTheme(shopTheme: string | null | undefined) {
    applyTheme(resolveTheme(shopTheme))
  }

  return {
    theme: readonly(current),
    applyTheme,
    applyShopTheme,
  }
}
